<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-回访-添加
    -->
    <el-dialog
    title="添加回访"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
 

      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入名称" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="选择商品" prop="product_id">
         <template>
           <div>
             <el-button icon="el-icon-plus" @click.stop="openProduct(product,false)">选择产品</el-button>
           </div>

           <table v-if="form.product_id" border cellspacing="0" class="mt10" 
           style="border: 1px solid #e8e8e8;">
             <tr style="border: 1px solid #e8e8e8;">
               <th class="w150" style="width: 250px;border: 1px solid #e8e8e8;">产品名称</th>

               <th class="w150" style="width: 150px;border: 1px solid #e8e8e8;">产品价格</th>
             </tr>
             <tr style="border: 1px solid #e8e8e8;">
               <td class="tc" style="border: 1px solid #e8e8e8;">{{product.product_name}}</td>
               <td class="tc" style="border: 1px solid #e8e8e8;">{{product.product_price}}</td>
             </tr>
           </table>
        </template>
      <!--组件样式-->
      </el-form-item>
      <el-form-item label="规则" >
        <el-button size="small" type="primary" @click="addTab" >新增规则</el-button>
        <el-button size="small" type="primary" style="background: #f72020;border: 1px solid #f72020;" @click="delTab" >删除规则</el-button>
        <el-tabs v-model="tab_index">
          <el-tab-pane :label="(index+1)+'.'+ form.tab[index].name" v-for="(item,index) in form.tab"  :key="index"></el-tab-pane>
         
        </el-tabs>

        
          <template  >
                <div class="d-s-c"  >
                  <el-input style="width: 550px;"  v-model="form.tab[tab_index].name"  placeholder="规则名称"></el-input>
                </div>

                <div>举例：事业中心(A)—招商中心(B)-运营中心(C)-普通用户(D)</div>
                <div>名称可用A-B-C-D</div>
              </template>


        <el-button size="small" type="primary" @click="addSetting" style="margin-top: 20px;">新增规则链</el-button>
        <el-table :data="form.tab[tab_index].setting"  border size="mini" style="width: 100%;margin-top: 20px;">
          
          
          <el-table-column prop="name" label="选择等级"   width="200" >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-select v-model="scope.row.grade_id" placeholder="请选择等级">
                    <el-option label="请选择等级" :value="-1"></el-option>
                    <el-option v-for="(item,index) in grade" :key="index" :label="item.name" :value="item.grade_id"></el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="name" label="说明"   width="200" >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-radio-group v-model="scope.row.type">
                    <el-radio  :label="1" >返利对象</el-radio>
                    <el-radio  :label="2" >购买对象</el-radio>
                 </el-radio-group>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="name" label="返利金额"   width="200" >
              <template v-slot="scope" >
                <div class="d-s-c"  >
                  <el-input style="width: 150px;"  type="number"  v-model="scope.row.price"  placeholder="请输入返利金额"></el-input>
                </div>

                <div >小于等于0，不进行返利</div>
              </template>
            </el-table-column>

        
         
            <el-table-column prop="name" label="操作"  width="100">
              <template v-slot="scope">
                <div style="color: blue;" @click="delSetting(scope.$index)">删除</div>

              </template>
            </el-table-column>
          </el-table>
      </el-form-item>
   
      
    
    
      <el-form-item label="状态" prop="status">

        <div >
            <el-radio-group v-model="form.status">
                <el-radio  :label="0" >关闭</el-radio>
                <el-radio  :label="1" >开启</el-radio>
            </el-radio-group>
        </div>
      </el-form-item>

     

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
    <!--选择商品-->
    <ProductSelect :isproduct="isproduct" :excludeIds="excludeIds" :islist="false" @closeDialog="closeProductDialogFunc($event)">产品列表弹出层</ProductSelect>
 
</el-dialog>
  
</template>

<script>
import rerulesApi from '@/api/rerules.js';
import ProductSelect from '@/components/product/Product';
import Order from '@/components/order/order'
export default {
  components: {
    Order,
    ProductSelect
  },
  data() {
    return {

      /*form表单数据*/
      form: {
        name: '',
       
        status:0,
        product_id:0,
        tab:[
          {
            name:"默认名称",
            setting:[],
          }

        ]
       
      },
      products:[],
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入回访名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      is_order:false,
      isproduct:false,
      excludeIds:[],
      grade:[],
      tab_index:0,
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getGrade()
  },
  props: ["open_add"],
  methods: {
    delTab(){
        let self = this;
        if(self.tab_index == 0){
          self.$message({
                message: "默认规则无法删除",
                type: 'error'
              });
              return;
        }
        self
          .$confirm('是否删除当前选择规则, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            console.log(self.tab_index)
            console.log(self.form.tab)
            var tab = self.form.tab;
            var tab_arr = [];
            for(var i=0;i < tab.length;i++){
              if(i != self.tab_index){
                tab_arr.push(tab[i])
              }
             
            }
            self.form.tab = tab_arr;
            self.tab_index = "0";
          })
          .catch(() => {
          });
      },
    getGrade(){
      let self = this;

      rerulesApi.getGrade({}, true)
        .then(data => {
          self.grade = data.data
        });
    },
         // /*商品选择关闭弹窗*/
    closeProductDialogFunc(e) {
      console.log("e.params",e.params)
      this.isproduct = false;
      if (e.type == 'success') {
        this.product= { product_id: e.params.product_id, product_image: e.params.image,
          product_name: e.params.product_name,product_price: e.params.product_price };
        this.form.product_id = e.params.product_id;
      }
    }, 
    /*商品选择列表弹出层*/
    openProduct(product, islist) {
      if(product){
        this.excludeIds = [form.product_id];
      }
      this.islist = false;
      this.isproduct = true;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":result });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    delSetting(index){
      this.form.tab[this.tab_index].setting.splice(index,1)
    },
    addTab(){
      this.form.tab.push({
        name:"默认名称",
        setting:[]
        
      })
    },
    addSetting(){
        this.form.tab[this.tab_index].setting.push({
          text:"",//等级名称
          grade_id:-1,//等级ID
          type:1,//1  返利对象  2  购买对象
          price:0,//返利金额
          
        });
      },
    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          rerulesApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    closeOrderFunc(e){
      console.log("e",e)
        this.is_order = false
        this.form.order_no = e.params.order_no
        this.form.order_id = e.params.order_id
    },
    chooseOrder(){
      this.is_order = true
    },
    
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/rerules/product/part/add.vue